"use client";

import { c as _c } from "react/compiler-runtime";
import { cn } from "@/utils/cn";
import React from "react";
import { Label, Text } from "react-aria-components";
type Option = {
  label: string;
  value: string;
  disabled?: boolean;
};
export interface RadioGroupInputProps {
  label?: string;
  labelClassName?: string;
  description?: string;
  errorMessage?: string;
  options?: Option[];
  value?: string;
  onChange: (value: string | null) => void;
  onBlur: () => void;
  className?: string;
  radioClassName?: string;
  children?: React.ReactNode;
  itemsClassName?: string;
}
export const RadioGroupInput = t0 => {
  const $ = _c(30);
  const {
    label,
    labelClassName,
    description,
    errorMessage,
    options,
    value,
    onChange,
    onBlur,
    className,
    radioClassName,
    children,
    itemsClassName: t1
  } = t0;
  const itemsClassName = t1 === undefined ? "grid grid-cols-2" : t1;
  let t2;
  if ($[0] !== onChange || $[1] !== value) {
    t2 = newValue => {
      onChange(value === newValue ? null : newValue);
    };
    $[0] = onChange;
    $[1] = value;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const handleChange = t2;
  let t3;
  if ($[3] !== className) {
    t3 = cn("group flex flex-col py-1 my-1 gap-1.5", className);
    $[3] = className;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== label || $[6] !== labelClassName) {
    t4 = label && <Label className={cn("text-title-medium", labelClassName)}>{label}</Label>;
    $[5] = label;
    $[6] = labelClassName;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== itemsClassName) {
    t5 = cn("gap-2", itemsClassName);
    $[8] = itemsClassName;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== children || $[11] !== handleChange || $[12] !== options || $[13] !== radioClassName || $[14] !== value) {
    t6 = options?.length ? options.map(t7 => {
      const {
        value: curValue,
        label: optionLabel,
        disabled
      } = t7;
      const isSelected = value === curValue;
      return <button key={curValue} type="button" role="radio" aria-checked={isSelected} disabled={disabled} onClick={() => !disabled && handleChange(curValue)} className={cn("flex items-start gap-2 px-4 py-3 rounded-xl border transition-all text-body w-full min-w-0", disabled ? "opacity-50 cursor-not-allowed border-neutral-200 text-neutral-400 bg-neutral-50" : "cursor-pointer", isSelected ? "bg-primary-400" : !disabled && "bg-white border-neutral-200 text-neutral-600 hover:border-primary-500", "border-primary-600 text-primary-600", radioClassName)}><span className={cn("w-4 h-4 rounded-full border flex items-center justify-center flex-shrink-0 mt-0.5", isSelected ? "border-primary-600" : "border-current")}>{isSelected && <span className="w-2 h-2 rounded-full bg-current flex-shrink-0" />}</span><div className="flex-1 min-w-0 text-left" style={{
          display: "-webkit-box",
          WebkitLineClamp: 2,
          WebkitBoxOrient: "vertical",
          overflow: "hidden",
          textOverflow: "ellipsis",
          lineHeight: "1.3",
          maxHeight: "2.6em",
          wordBreak: "break-word"
        }} title={optionLabel}>{optionLabel}</div></button>;
    }) : children;
    $[10] = children;
    $[11] = handleChange;
    $[12] = options;
    $[13] = radioClassName;
    $[14] = value;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== t5 || $[17] !== t6) {
    t7 = <div className={t5}>{t6}</div>;
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== description) {
    t8 = description && <Text slot="description" className="text-body-small">{description}</Text>;
    $[19] = description;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  const t9 = errorMessage || "";
  let t10;
  if ($[21] !== t9) {
    t10 = <Text slot="errorMessage" className="text-body-small-medium text-destructive h-1">{t9}</Text>;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== onBlur || $[24] !== t10 || $[25] !== t3 || $[26] !== t4 || $[27] !== t7 || $[28] !== t8) {
    t11 = <div role="radiogroup" onBlur={onBlur} className={t3}>{t4}{t7}{t8}{t10}</div>;
    $[23] = onBlur;
    $[24] = t10;
    $[25] = t3;
    $[26] = t4;
    $[27] = t7;
    $[28] = t8;
    $[29] = t11;
  } else {
    t11 = $[29];
  }
  return t11;
};